import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';

const ShaftSeal = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Shaft Seal Housing</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.shaftSealQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.shaftSealType'
                type='text'
                control={control}
                label='Type'
                options={[
                    {
                        label: 'Lip',
                        id: 'Lip'
                    },
                    {
                        label: 'Carbon',
                        id: 'Carbon'
                    },
                    {
                        label: 'Ceramic Felt',
                        id: 'Ceramic Felt'
                    },
                    {
                        label: 'Plate',
                        id: 'Plate'
                    }
                ]}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.shaftSealNotes'
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
        </>
    );
};

export default ShaftSeal;
